import React from 'react';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { EarningsIcon } from '../icons/EarningsIcon';
import { Information } from '../Information';
import { ComparePreset } from '../../model/datePicker/types';
import { t } from '../../i18n';

const Earnings = ({ value, previousValue, comparePreset }: Props) => {
  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center mb-2">
        <Information id="earnings" content={<small className=" text-gray-12 me-2">{t('productSales.earnings')}</small>} />
        <Information id="earnings" showMore={true} />
      </div>
      <div className="d-flex align-items-center">
        <EarningsIcon />
        <h1 className="ms-2 mb-0 text-gray-12">{value.toFixed(2)}€</h1>
      </div>
      <div className="mt-2">
        <small className="d-flex align-items-center" style={{ marginTop: 1 }}>
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-gray-12 fs-7">{getComparePresetLabel(comparePreset)} ({previousValue.toFixed(2)}€)</div>
        </small>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  previousValue: number,
  comparePreset?: ComparePreset
}

export { Earnings };